/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_boxesCarousel", {
        options: {
            slickOptions:{
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                rows: 0,
                pauseOnFocus: false, 
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.desktop, // tablet view
                        settings: {
                            slidesToShow:2
                        }
                    },
                    {
                        breakpoint: api.vars.scr.tablet, // mobile view
                        settings: {
                            slidesToShow:1
                        }
                    }
                ],
            }
        },

        _create: function () {
            this.wrap = this.element;

            $('.s-boxes__items', this.wrap).each((indx, el)=>{                
                $(el).on('init', (slick)=>{
                    var dots = $('.slick-dots', $(slick.target))  
                    api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed/1000)
                })
                .slick(this.options.slickOptions)
                .on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
                    var dots = $('.slick-dots', $(event.target))
                    api.fn.slickDotsFilled(dots, nextSlide)
                })
            });
        }           

    });
})(jQuery);



